module.exports = __webpack_public_path__ + "static/logo-161e14d04257d42fae1aa8fe9c5633d4.svg";